
const cobh = [
    { 
    label:"Change in frequency:",
    controlType:"radio button",
    options:["No change", "Increased Frequency,", "Decreased Frequency", "Alternating Inc and Dec"]
    },   
    
    { 
    label:"Current frequency:",
    controlType:"radio button",
    options:["<2 stools/week,", "<1 stool/day", "1-3 stools/day", "4-5 stools day", "5-10 stools/day",">10 stools/day" ]
    },

    {label:"Change in consistency:",
    controlType:"radio button",
    options:["No change", "Harder", "Softer", "Liquid", "Alternating hard and soft"]
    },

    {label:"Urgency:",
    controlType:"radio button",
    options:["Yes", "No"],
    },

    {label:"Tenesmus:",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {label:"Incontinence / soiling:",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {
    label:"Occurrance",
    controlType:"radio button",
    options:["Every day", "Most days", "Evey week or two", "Occasionally"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]


export default cobh